// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Typography, Grid} from '@material-ui/core';
// import LanguageIcon from '@mui/icons-material/Language';
import {Language} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import UpgradeIcon from '../../../../elements/icons/UpgradeIcon';

type Props = {|
  open: boolean,
  handleClose: () => void,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 600,
    padding: theme.spacing(4, 0),
    overflow: 'hidden',
  },
  productContainer: {
    height: '70%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    width: '100%',
  },
  subtitle: {
    fontWeight: 600,
    fontSize: '14px',
    width: '100%',
  },
  domainRow: {
    margin: '16px 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  domain: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    border: `1px solid ${colors.grey500}`,
    borderRadius: 32,
    paddingLeft: 12,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      justifyContent: 'space-between',
      maxWidth: 365,
    },
  },
  domainCustom: {
    fontSize: 12,
    color: colors.grey700,
    fontWeight: 600,
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 20,
    },
  },
  domainText: {
    fontSize: 12,
    padding: '8px 12px',
    color: colors.purple,
    background: '#EEE5FF',
    borderRadius: 32,
    fontWeight: 600,
  },
  text: {
    color: colors.grey700,
    fontSize: 12,
    width: '100%',
    textAlign: 'start',
  },
  link: {
    color: colors.purple,
    fontWeight: 700,
    textDecoration: 'none',
    width: '100%',
    display: 'block',
    textAlign: 'start',
  },
  subItem: {
    display: 'block',
    marginLeft: 8,
  },
  rootDomain: {
    marginTop: 16,
    marginLeft: theme.spacing(1),
  },
  helperTextValid: {
    color: colors.success,
  },
  divider: {
    position: 'relative',
    width: '100%',
    margin: '16px 0',

    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      width: '100%',
      height: 1,
      background: colors.grey200,
      zIndex: 0,
    },
  },
  dividerContent: {
    fontSize: 22,
    fontWeight: 600,
    color: 'white',
    background: colors.purple3,
    width: 44,
    height: 44,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    position: 'relative',
  },
  exampleWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1,
    '&:after': {
      content: '"."',
      position: 'absolute',
      width: '35%',
      height: 'auto',
      aspectRatio: '1/1',
      borderRadius: '50%',
      background: '#EDE4FF',
      zIndex: -1,
    },
  },
  example: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${colors.grey500}`,
    padding: '4px 6px 4px 4px',
    borderRadius: 32,
    background: 'white',
    gap: '4px',
    '& span': {
      color: colors.grey700,
      fontSize: 12,
    },
    '& svg': {
      color: colors.purple,
    },
  },
  linkLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
  },
}));

export default function UpgradeCustomDomainModal(props: Props) {
  const {open, handleClose} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Sitio URL
        </Typography>
        <Typography className={classes.subtitle} align="left">
          Usa nuestro dominio gratuito
        </Typography>
        <div className={classes.domainRow}>
          <div className={classes.domain}>
            <Typography className={classes.domainCustom}>home</Typography>
            <Typography className={classes.domainText}>
              .tiendada.com
            </Typography>
          </div>
        </div>
        <Typography className={classes.text} paragraph>
          Te brindamos un subdominio de TiendaDa. Se customiza con el nombre de
          tu marca. Recuerda que para acceder a tu panel siempre usarás este
          subdominio/admin.
        </Typography>
        <div className={classes.divider}>
          <span className={classes.dividerContent}>Ó</span>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.exampleWrap}>
            <div className={classes.example}>
              <Language color="#7B39FF" />
              <span>www.home.com</span>
            </div>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.subtitle} align="left">
              Usa nuestro dominio gratuito
            </Typography>
            <Typography className={classes.text} paragraph>
              Te brindamos un subdominio de TiendaDa. Se customiza con el nombre
              de tu marca. Recuerda que para acceder a tu panel siempre usarás
              este subdominio/admin.
            </Typography>
            <CustomButton className={classes.link} to="/tiers-list">
              <div className={classes.linkLabel}>
                Actualiza tu plan Mejorar <UpgradeIcon width={18} height={18} />
              </div>
            </CustomButton>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
}

UpgradeCustomDomainModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
